export default "__VITE_ASSET__052ec836__"